module.exports = __webpack_public_path__ + "img/3-participated.94bacf86.png";